window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) { }

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

//Object Filter
Object.filter = (obj, predicate) =>
    Object.keys(obj)
        .filter(key => predicate(obj[key]))
        .reduce((res, key) => (res[key] = obj[key], res), {});

String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1)
}

window.capitalizeFirstLetter = function (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

window.searchArrayByKey = function (key, list, field = 'id', seeking = 'object') {
    for (var i = 0; i < list.length; i++) {
        if (list[i][field] == key) {
            if (seeking == 'object') {
                return list[i];
            } else {
                return i;
            }

        }
    }
}

/**
 * Calculate Dont Miss Score for a game based on thuuz data and zip distance
 * @param {Object} game - The game object containing thuuz_game and team data
 * @returns {number} The calculated Dont Miss Score
 */
window.calculateDmsScore = function (game) {
    // console.log('Calculating DMS score for game:', game.id);
    // Base score from Thuuz if available, otherwise use a neutral base
    const NEUTRAL_BASE_SCORE = 50; // Middle of 1-100 range
    const MAX_DISTANCE = 300000; // 300km in meters
    const MAX_DISTANCE_BOOST = 25; // Maximum boost for local games

    let baseScore = game.thuuz_game ? game.thuuz_game.gex_default : NEUTRAL_BASE_SCORE;
    let proximityBoost = 0;

    // Calculate proximity boost based on zip distances
    const awayZips = game.away_team?.zips || [];
    const homeZips = game.home_team?.zips || [];


    // If no zips for either team, return base score only
    if (awayZips.length === 0 && homeZips.length === 0) {
        // console.log('No zips found - returning base score:', baseScore);
        return baseScore;
    }

    // Find the closest distance for each team
    const awayDistance = awayZips.length > 0 ? Math.min(...awayZips.map(zip => zip.pivot.distance)) : MAX_DISTANCE;
    const homeDistance = homeZips.length > 0 ? Math.min(...homeZips.map(zip => zip.pivot.distance)) : MAX_DISTANCE;

    // Calculate proximity boost based on distance (closer = higher boost)
    const awayProximityBoost = calculateProximityBoost(awayDistance, MAX_DISTANCE, MAX_DISTANCE_BOOST);
    const homeProximityBoost = calculateProximityBoost(homeDistance, MAX_DISTANCE, MAX_DISTANCE_BOOST);

    // Apply proximity boost logic
    if (awayZips.length > 0 && homeZips.length > 0) {
        // Both teams are local - use average of both boosts
        proximityBoost = (awayProximityBoost + homeProximityBoost) / 2;
        // console.log('Both teams local - proximity boost:', proximityBoost);
    } else if (homeZips.length > 0) {
        // Only home team is local
        proximityBoost = homeProximityBoost;
        // console.log('Home team local - proximity boost:', proximityBoost);
    } else if (awayZips.length > 0) {
        // Only away team is local
        proximityBoost = awayProximityBoost;
        // console.log('Away team local - proximity boost:', proximityBoost);
    }

    // For games with Thuuz data, blend proximity boost with existing adjustments
    if (game.thuuz_game) {
        let thuuzAdjustment = 0;

        if (awayZips.length > 0 && homeZips.length > 0) {
            thuuzAdjustment = (game.thuuz_game.gex_home_adjust + game.thuuz_game.gex_away_adjust) / 2;
        } else if (homeZips.length > 0) {
            thuuzAdjustment = game.thuuz_game.gex_home_adjust;
        } else if (awayZips.length > 0) {
            thuuzAdjustment = game.thuuz_game.gex_away_adjust;
        }

        // Blend Thuuz adjustment with proximity boost (weighted toward Thuuz for consistency)
        proximityBoost = (thuuzAdjustment * 0.7) + (proximityBoost * 0.3);
        // console.log('After Thuuz blend - final proximity boost:', proximityBoost);
    }

    const finalScore = Math.round(baseScore + proximityBoost);
    // console.log('Final DMS score:', finalScore);
    return finalScore;
};

/**
 * Calculate proximity boost based on distance
 * @param {number} distance - Distance in meters
 * @param {number} maxDistance - Maximum distance threshold in meters
 * @param {number} maxBoost - Maximum boost value
 * @returns {number} The calculated proximity boost
 */
function calculateProximityBoost(distance, maxDistance, maxBoost) {
    if (distance >= maxDistance) return 0;

    // Use inverse square root for more gradual falloff
    // This gives more weight to very close games while still providing boost for distant ones
    const normalizedDistance = distance / maxDistance; // 0 to 1
    const proximityFactor = Math.sqrt(1 - normalizedDistance); // Square root for gradual falloff

    return maxBoost * proximityFactor;
}

/**
 * Alternative linear proximity calculation (simpler falloff)
 */
/*
function calculateProximityBoost(distance, maxDistance, maxBoost) {
    if (distance >= maxDistance) return 0;
    return maxBoost * (1 - (distance / maxDistance));
}
*/
